
import React, { useRef, useEffect, PropsWithChildren } from 'react';
import { Fancybox as NativeFancybox } from '@fancyapps/ui';
import '@fancyapps/ui/dist/fancybox/fancybox.css';
import { OptionsType } from '@fancyapps/ui/types/Fancybox/options';

interface Props {
  options?: Partial<OptionsType>;
  delegate?: string;
}

function Fancybox(props: PropsWithChildren<Props>) {
  const containerRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const container = containerRef.current;

    const options = {
      Toolbar: {
        display: {
          left: ["infobar"],
          middle: [],
          right: [" ", "zoom",  "download", "thumbs", "close"],
        },
      },
    };

    if (container) {
      NativeFancybox.bind(container, props.delegate || '[data-fancybox]', options);

      return () => {
        NativeFancybox.unbind(container);
        NativeFancybox.close();
      };
    }
  }, [props.options, props.delegate]);

  return <div ref={containerRef}>{props.children}</div>;
}

export default Fancybox;